
export enum TemplateType {
    DASHBOARD_PROJECT   = 1,
    DASHBOARD_CUSTOM    = 2,
    DASHBOARD_USER      = 3,
    TODO_LIST           = 4
}


export enum TemplateAccess {
    GOODDAY = 1,    // Public for all companies
    COMPANY = 2,    // all users in company
    PRIVATE = 3     // private
}